// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2GYtN","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__CpTWh"};